module.exports = __webpack_public_path__ + "static/media/nc.564ebcc5.svg";